// extracted by mini-css-extract-plugin
export default {"loginButtonContainer":"GoogleLogin_loginButtonContainer__LAMCn"};